// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7d6c2aeb","703":"e291c492","787":"114677b5"}[chunkId] + ".chunk.js";
};